import { gql } from '@apollo/client';

const fragments = {
  projectReport: gql`
    fragment projectReport on ProjectReport {
      id
      name
      description
      powerbiUrl
      isActive
    }
  `,
};

export const GET_REPORTS = gql`
  query reports($input: ReportInput, $paging: PagingInput) {
    reports(input: $input, paging: $paging) {
      total
      cursor
      items {
       ...projectReport
      }
    }
    ${fragments.projectReport}
  }
`;

export const GET_REPORT_BY_ID = gql`
  query reportByIds($ids: [ID!]!) {
    reportByIds(ids: $ids) {
      ...projectReport
    }
    ${fragments.projectReport}
  }
`;

export const UPDATE_PROJECT_REPORT = gql`
  mutation updateProjectReport($input: UpdateProjectReportInput!) {
    updateProjectReport(input: $input) {
      projectReport {
        ...projectReport
      }
      error
    }
    ${fragments.projectReport}
  }
`;

export const ADD_PROJECT_REPORT = gql`
  mutation addProjectReport($input: AddProjectReportInput!) {
    addProjectReport(input: $input) {
      projectReport {
        ...projectReport
      }
      error
    }
    ${fragments.projectReport}
  }
`;

export const DELETE_PROJECT_REPORT = gql`
  mutation deleteProjectReport($input: DeleteProjectReportInput!) {
    deleteProjectReport(id: $input) {
      projectReport {
        id
      }
      error
    }
  }
`;
